import styled from "styled-components";
import Img from "../../Img";

export const Wrapper = styled.div`
  display: flex;
  width: 14px;
  height: 10px;
  cursor: pointer;
`;

export const Image = styled(Img)`
  display: flex;
  width: 100%;
  height: 100%;
`;
